import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGetNotifyParams } from '../models/notifications.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private httpService: HttpService) { }

  getNotifications(params: IGetNotifyParams = { page: 1, limit: 10 }): Observable<any> {
    return this.httpService.get('/student/notifications', params);
  }

  updateLastSeen(): Observable<any> {
    return this.httpService.put('/student/notifications/last-seen', {});
  }

  updateSeen(notifyId: string): Observable<any> {
    return this.httpService.put(`/student/notifications/${notifyId}/seen`, { 'seen': false });
  }
}
